var map = {
	"./Avisos.png": 94069,
	"./Endosos.png": 33365,
	"./Historial_de_Siniestros.png": 22523,
	"./Hoy_no_Circula.png": 94613,
	"./Informacion_de_Pagos.png": 15588,
	"./Informacion_de_Polizas.png": 72779,
	"./Multas.png": 20661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53544;